import { notDesktop, styled } from '@obvio/app'
import { Accordion as AccordionUi } from '@obvio/ui'

const Element = styled(AccordionUi.Element)`
  border-bottom: thin solid black;
  > div {
    padding: ${(theme) => theme.spacing.medium} 0;
  }
  > p {
    margin-bottom: 2rem;
  }
`

const Accordion = AccordionUi

Accordion.Element = Element

const AccordionTitle = styled.span`
  font-family: ${(theme) => theme.secondaryFont};
  font-size: 1.375rem;
  padding-left: ${(theme) => theme.spacing.extraSmall};
  @media ${notDesktop} {
    padding-left: 0;
  }
`

const AccordionHead = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${(theme) => theme.spacing.extraSmall};
  border-bottom: thin solid black;
  align-items: center;
  width: 100%;
`

export { Accordion, AccordionTitle, AccordionHead }
